import React from "react";
import { BrowserRouter } from "react-router-dom";
import { RouterConfig } from "./navigation/RouterConfig";
import "./index.css";
import "./styles/main.scss";
import "./styles/login.scss";
import "./styles/app.scss";
import { ProvideAuth } from "./navigation/Auth/ProvideAuth";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "./i18n";

function App() {
  window.onunhandledrejection = (err) => {
    if (
      err &&
      err.reason &&
      err.reason.hasOwnProperty("status") &&
      err.reason.status === 401
    ) {
      window.localStorage.clear();
      window.location.reload();
    }
  };

  return (
    <Provider store={store}>
      <ProvideAuth>
        <BrowserRouter>
          <RouterConfig />
        </BrowserRouter>
      </ProvideAuth>
    </Provider>
  );
}

export default App;
